<template>
  <nav class="navbar navbar-light bg-white shadow-sm sticky-top">
    <div class="container justify-content-center">
      <a href="#">
        <img
          class="img-fluid navbar-logo"
          src="@/assets/images/logo.svg"
          alt="IntelliKid Systems"
        />
      </a>
    </div>
  </nav>
</template>

<script lang="ts" setup />
